import { render, staticRenderFns } from "./AgentCard.vue?vue&type=template&id=6487d998&scoped=true&"
import script from "./AgentCard.vue?vue&type=script&lang=js&"
export * from "./AgentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6487d998",
  null
  
)

export default component.exports